import React, { useState } from "react";
import axios from "axios";
import util from "../../utils/miniUtils";
import { apiErrorMessage } from "./apiError";
import "./Login.css";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 100;

// Página pública del link de activación o recuperación: /definir-contrasena?token=...
function PasswordReset (){

    const [token] = useState( () => new URLSearchParams( window.location.search ).get( "token" ) );
    const [password, setPassword] = useState( "" );
    const [passwordConfirm, setPasswordConfirm] = useState( "" );
    const [loading, setLoading] = useState( false );

    async function changePasswordRequest () {
        try {
            if ( password.length < MIN_PASSWORD_LENGTH ) throw new Error( `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres` );
            if ( password.length > MAX_PASSWORD_LENGTH ) throw new Error( `La contraseña debe tener máximo ${MAX_PASSWORD_LENGTH} caracteres` );
            if ( passwordConfirm !== password ) throw new Error( "Las contraseñas no son iguales" );
            setLoading( true );
            const request = await axios.post( `${BASE_URL}/auth/password/set`, { token, password } );
            const { error, msg } = request.data;
            if ( error ) throw msg;
            util.toast().success( msg );
            setTimeout( () => {
                window.location.replace( "/" );
            }, 1500 );
        } catch ( e ) {
            setLoading( false );
            util.handleError( apiErrorMessage( e ) );
        }
    }

    function captureEnterKey ( e ) {
        if ( e.key === "Enter" ) {
            changePasswordRequest().then( null );
        }
    }

    return (
        <div className="krs-login-wrapper">
            <div className="krs-login-container">
                <div className="krs-login-card">
                    <div className="krs-login-header">
                        <h1 className="krs-login-title">KRSMotocicletas</h1>
                        <p className="krs-login-subtitle">Define tu contraseña</p>
                    </div>

                    {!token ? (
                        <div className="krs-login-form">
                            <p className="krs-form-message">
                                El link no es válido. Pide uno nuevo con «¿Olvidaste tu contraseña?» en el inicio de sesión.
                            </p>
                            <button className="krs-btn-submit" type="button" onClick={() => window.location.replace( "/" )}>
                                Ir a iniciar sesión
                            </button>
                        </div>
                    ) : (
                        <div className="krs-login-form">
                            <div className="krs-form-group">
                                <label className="krs-form-label">Nueva contraseña</label>
                                <input
                                    disabled={loading}
                                    onKeyDown={captureEnterKey}
                                    onChange={( e ) => setPassword( e.target.value )}
                                    type="password"
                                    className="krs-input krs-input-no-icon"
                                    name="password"
                                    autoComplete="new-password"
                                    placeholder={`Mínimo ${MIN_PASSWORD_LENGTH} caracteres`}
                                />
                            </div>

                            <div className="krs-form-group">
                                <label className="krs-form-label">Confirmar contraseña</label>
                                <input
                                    disabled={loading}
                                    onKeyDown={captureEnterKey}
                                    onChange={( e ) => setPasswordConfirm( e.target.value )}
                                    type="password"
                                    className="krs-input krs-input-no-icon"
                                    name="passwordConfirmation"
                                    autoComplete="new-password"
                                    placeholder="••••••••"
                                />
                            </div>

                            <button
                                disabled={loading}
                                onClick={changePasswordRequest}
                                className="krs-btn-submit"
                                type="button">
                                {loading ? "Guardando..." : "Guardar contraseña"}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {util.LOADING_SCREEN( loading )}
        </div>
    );

}

export default PasswordReset;
